module.exports = __webpack_public_path__ + "static/media/privacy-policy.682d732a.png";